module.exports = __webpack_public_path__ + "img/Auto Canceled.86ac94f2.png";